import { Typeahead as BaseTypeahead } from 'react-bootstrap-typeahead';
import { Add, ChevronLeftV2, GripDots } from 'src/shared/design-system/Icon';
import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const AddIcon = Add;

export const BackIcon = ChevronLeftV2;

export const GripIcon = GripDots;

export const Typeahead = styled(BaseTypeahead).attrs(() => ({
  labelKey: 'title',
}));

export const Container = styled.div`
  width: 100%;
`;

export const TypeaheadContainer = styled.div`
  ${Mixins.Flex.center()}
  position: relative;
  & + & {
    margin-top: ${Spacing.HALF};
  }

  .rbt {
    background-color: transparent !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    width: 100%;

    & > div {
      width: 100%;
      flex: 1;

      & input {
        border: ${Border.Base} ${Colors.GRAY_LITE_10};
        border-radius: ${Border.Radius.M};
        box-shadow: none;
        outline: none;
        padding: ${Spacing.SINGLE} ${Spacing.SINGLE_HALF} ${Spacing.SINGLE} ${Spacing.TRIPLE};
        margin: 0 !important;
        width: 100%;
        transition: font-size ${Transition.Time.BASE}, font ${Transition.Time.BASE};
        ${Font.bySize(Font.Size.S)}

        &::placeholder {
          color: ${Colors.GRAY_DARK_20};
          font-size: ${Font.Size.S};
          font-weight: bold;
          transition: font-weight ${Transition.Time.BASE}, text-indent ${Transition.Time.BASE};
        }

        &:focus::placeholder {
          font-weight: normal;
        }
      }
    }
    & .rbt-menu {
      border: ${Border.Base} ${Colors.GRAY_DARK_10};
    }
    & .dropdown-menu {
      position: absolute;
      display: none;
      float: left;
      border-radius: 0px;
      box-shadow: none;
      padding: ${Spacing.HALF};
      text-align: left;
      list-style: none;
      background-clip: padding-box;
      background: ${Colors.WHITE};
      z-index: 1000;
    }
    & .dropdown-item {
      ${Font.bySize(Font.Size.S)}
      font-size: ${Font.Size.S} !important;
      display: block;
      width: 100%;
      padding: ${Spacing.QUARTER} ${Spacing.HALF};
      clear: both;
      text-align: inherit;
      white-space: nowrap;
      border: 0;
      color: inherit;
      text-decoration: none;

      & mark {
        background-color: ${Colors.JACKFRUIT_LITE_10};
        padding: 0;
      }

      &.active {
        background: ${Colors.JACKFRUIT_LITE_30};
      }
    }
  }
`;

export const CuisineTagContainer = styled.div<{ sortable?: boolean }>`
  background: ${Colors.GRAY_LITE_30};
  display: flex;
  flex-direction: ${ifProp('sortable', 'column', 'row')};
  flex-wrap: wrap;
  position: relative;
  padding: ${Spacing.SINGLE};
  margin-bottom: ${Spacing.SINGLE};
  gap: ${Spacing.HALF};

  &:empty {
    padding: 0;
    margin-bottom: 0;
  }

  & > div {
    margin: 0;
  }
`;

export const GripContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0 ${Spacing.HALF};
`;

export const BaseIconContainer = styled.div`
  box-sizing: border-box;
  ${Mixins.Flex.center()}
  ${Mixins.Shape.square(Spacing.SINGLE_HALF)}
  cursor: pointer;
  color: ${Colors.GRAY_DARK_20};

  & svg {
    ${Mixins.Shape.square(Spacing.SINGLE_HALF)}
  }
`;

export const AddIconContainer = styled(BaseIconContainer)``;

export const BackIconContainer = styled(BaseIconContainer)`
  border: ${Border.Base} ${Colors.GRAY_LITE_20};
  border-radius: 100%;
  padding: ${Spacing.EIGHTH};
`;

export const IconContainer = styled.div<{ disabled?: boolean }>`
  box-sizing: border-box;
  position: absolute;
  left: ${Spacing.SINGLE};
  top: 15px;
  opacity: 1;
  pointer-events: none;
  transition: opacity ${Transition.Time.BASE};

  ${AddIconContainer} {
    display: flex ${ifProp('disabled', ' !important', '')};
  }
  ${BackIconContainer} {
    display: none ${ifProp('disabled', ' !important', '')};
  }

  .rbt:focus-within + & {
    pointer-events: all;
    ${AddIconContainer} {
      display: none;
    }
    ${BackIconContainer} {
      display: flex;
    }
  }
`;

export const TipsContainer = styled.div`
  background: ${Colors.GRAY_LITE_10};
  border-radius: ${Border.Radius.M};
  padding: ${Spacing.SINGLE};
`;
